import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
export function Footer() {
  const [modalType, setModalType] = useState<'terms' | 'privacy' | null>(null);
  return <>
      <footer className="bg-[#0f1923] py-8 border-t border-gray-800 text-center text-gray-500 text-sm" data-id="element-35">
        <div className="container mx-auto px-6 space-y-3" data-id="element-36">
          <p data-id="element-37">
            &copy; {new Date().getFullYear()} Plan Anti-Pantalla. Todos los
            derechos reservados.
          </p>
          <div className="flex items-center justify-center gap-4" data-id="element-38">
            <button onClick={() => setModalType('terms')} className="text-gray-500 hover:text-[#c9a84c] transition-colors underline underline-offset-2" data-id="element-39">
              Términos y Condiciones
            </button>
            <span className="text-gray-700" data-id="element-40">•</span>
            <button onClick={() => setModalType('privacy')} className="text-gray-500 hover:text-[#c9a84c] transition-colors underline underline-offset-2" data-id="element-41">
              Política de Privacidad
            </button>
          </div>
        </div>
      </footer>

      <LegalModal isOpen={modalType !== null} onClose={() => setModalType(null)} type={modalType ?? 'terms'} data-id="element-42" />
    </>;
}